<template>
    <base-input :label="label" :appendIcon="'ni ni-calendar-grid-58 text-blue'">
        <date-picker v-model="date" :config="datePickerOptions" @dp-change="dateChanged()" />
    </base-input>
</template>

<script>
export default {
    name:'timestamp-picker',
    props:{
        field:String,
        label:String
    },
    data(){
        return {
            datePickerOptions:{
                // https://momentjs.com/docs/#/displaying/
                format: 'DD/MM/YYYY HH:mm:ss',
                useCurrent: false,
                showClear: true,
                showClose: true,
                showTodayButton:true,
            },

            date:null,
            timestamp:null,
        }
    },
    methods:{
        dateChanged(){
            this.timestamp=this.datetimeToTimestamp(this.date)
            this.$emit('change',[this.field,this.timestamp])
        }
    },
}
</script>

<style>

</style>